import { useCallback } from 'react';

import { useCaptureException } from '@zenbusiness/application-commons-logging';
import { WebView } from '@zenbusiness/application-commons-webview';

import { TOKEN_TYPES } from '#client/constants/tokens';
import useCustomerToken from '#client/hooks/useCustomerToken';
import useUnitAccountId from '#client/hooks/useUnitAccountId';
import { launchCheckDepositWithNativeApp } from '#client/utils/bridge';

export default function useMobileCheckDeposit() {
  const { isWebView } = WebView;
  const captureException = useCaptureException();

  const { unitAccountId } = useUnitAccountId();

  const { error, loading, getCustomerToken } = useCustomerToken({
    type: TOKEN_TYPES.MOBILE_CHECK_DEPOSITS
  });

  const launchCheckDeposit = useCallback(async () => {
    try {
      // Fetch the customer token
      const customerToken = await getCustomerToken();

      // Check if customerToken or unitAccountId is missing
      if (!customerToken || !unitAccountId) {
        captureException(
          new Error(
            `Missing fields: ${!customerToken ? 'customerToken' : ''} ${!unitAccountId ? 'unitAccountId' : ''}`
          ),
          {
            level: 'warning'
          }
        );
        return;
      }

      // If the mobile check deposit feature is enabled, launch the check deposit with native app
      if (isWebView) {
        launchCheckDepositWithNativeApp({
          unitAccountId,
          customerToken,
          redirectUrl: window.location.pathname
        });
      }
    } catch (err) {
      // Capture any unexpected exceptions
      captureException(err);
    }
  }, [captureException, getCustomerToken, isWebView, unitAccountId]);

  return {
    error,
    loading,
    isEnableMobileCheckDeposit: isWebView,
    launchCheckDeposit
  };
}
